/**
 * **Anfassen nach dem Einhängen** (#204): Die eingehängte Aufgabe steht danach angefasst in
 * der Checkliste ihres Ziels. Die Liste, die sie zuerst zeigt, holt sich den Wunsch ab —
 * über ein Modul und nicht über Props, weil zwischen Ziehen und Checkliste vier Ebenen
 * liegen und die Zeile erst erscheint, wenn die Datenbank geschrieben ist.
 */
let pending: readonly string[] | null = null
const listeners = new Set<() => void>()

/** Eine oder mehrere Zeilen (mehrere umgehängt oder eingehängt: alle angefasst). */
export function setPendingSubtaskSelection(ids: string | readonly string[] | null): void {
  pending = typeof ids === 'string' ? [ids] : ids && ids.length > 0 ? ids : null
  if (pending) listeners.forEach(listener => listener())
}

/**
 * Meldet jede neue Vormerkung. Für eine Checkliste, die schon dasteht und deren Zeilen sich nicht
 * ändern — die Karte war offen, als der Zettel auf der Pinnwand geklickt wurde (#204, Grill 7).
 */
export function onPendingSubtaskSelection(listener: () => void): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

/** Die gewünschten Zeilen, wenn alle unter `ids` stehen — und nur einmal. */
export function takePendingSubtaskSelection(ids: readonly string[]): string[] | null {
  if (!pending || !pending.every(id => ids.includes(id))) return null
  const wanted = [...pending]
  pending = null
  return wanted
}

/** Die aktuelle Vormerkung, ohne sie abzuholen — wer vorgemerkt hat, erkennt die eigene daran. */
export function peekPendingSubtaskSelection(): readonly string[] | null {
  return pending
}

/** Wartet eine Zeile darauf, angefasst zu werden? Dann holt sich die aufklappende Karte keinen Fokus. */
export function hasPendingSubtaskSelection(): boolean {
  return pending !== null
}
